<template>
    <!-- Plant info -->
    <v-hover>
        <template v-slot="{ hover }">
            <v-card outlined :elevation="hover ? 6 : 1" :loading="loading">
                <slot name="header"></slot>
                <div class="pa-3">
                    <v-row align="center" class="mx-0">
                        <!-- Plant Species -->
                        <v-col cols="12" sm="4" lg="12">
                            <div class="caption grey--text text--darken-2">Plant Species</div>
                            <div class="subtitle-2">{{ plant.plantSpecies.name }}</div>
                        </v-col>

                        <!-- Plant Name -->
                        <v-col cols="12" sm="4" lg="12">
                            <div class="caption grey--text text--darken-2">Plant Name</div>
                            <div class="subtitle-2">{{ plant.name }}</div>
                        </v-col>

                        <!-- Default Supplier -->
                        <v-col cols="12" sm="4" lg="12">
                            <div class="caption grey--text text--darken-2">Default Supplier</div>
                            <div
                                class="subtitle-2"
                            >{{ plant.defaultSupplier ? plant.defaultSupplier.name : "-" }}</div>
                        </v-col>

                        <!-- Pot Sizes -->
                        <v-col cols="12" sm="6" md="3" lg="12">
                            <div class="caption grey--text text--darken-2">
                                <v-avatar left>
                                    <v-icon>straighten</v-icon>
                                </v-avatar>Pot Sizes
                            </div>
                            <v-chip-group column dark v-if="hasPlantPotSizes">
                                <v-chip
                                    v-for="item in sortedPotSizes"
                                    :key="item.node.id"
                                    color="primary"
                                >{{ item.node.potSize.potSizeCm }} cm</v-chip>
                            </v-chip-group>
                            <div v-else>-</div>
                        </v-col>

                        <!-- Colors -->
                        <v-col cols="12" sm="6" md="3" lg="12">
                            <div class="caption grey--text text--darken-2">
                                <v-avatar left>
                                    <v-icon>color_lens</v-icon>
                                </v-avatar>Colors
                            </div>
                            <v-chip-group column dark v-if="hasPlantColors">
                                <v-chip
                                    v-for="item in plant.plantColorSet.edges"
                                    :key="item.node.id"
                                    color="primary"
                                >{{ item.node.color.color }}</v-chip>
                            </v-chip-group>
                            <div v-else>-</div>
                        </v-col>

                        <!-- Environments -->
                        <v-col cols="12" sm="6" md="3" lg="12">
                            <div class="caption grey--text text--darken-2">
                                <v-avatar left>
                                    <v-icon>blur_on</v-icon>
                                </v-avatar>Environments
                            </div>
                            <v-chip-group column dark v-if="hasPlantEnvironments">
                                <v-chip
                                    v-for="item in plant.plantEnvironmentSet.edges"
                                    :key="item.node.id"
                                    color="primary"
                                >{{ item.node.environment.environment }}</v-chip>
                            </v-chip-group>
                            <div v-else>-</div>
                        </v-col>

                        <!-- Tags -->
                        <v-col cols="12" sm="6" md="3" lg="12">
                            <div class="caption grey--text text--darken-2">
                                <v-avatar left>
                                    <v-icon>turned_in_not</v-icon>
                                </v-avatar>Tags
                            </div>
                            <v-chip-group column dark v-if="hasPlantTags">
                                <v-chip
                                    v-for="item in plant.plantTagSet.edges"
                                    :key="item.node.id"
                                    color="primary"
                                >{{ item.node.tag.tag }}</v-chip>
                            </v-chip-group>
                            <div v-else>-</div>
                        </v-col>
                    </v-row>
                </div>

                <slot name="footer"></slot>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
export default {
    name: "plant-info-card",
    props: ["plant", "loading"],
    computed: {
        hasPlantColors: function () {
            return this.plant.plantColorSet.edges.length > 0;
        },
        hasPlantEnvironments: function () {
            return this.plant.plantEnvironmentSet.edges.length > 0;
        },
        hasPlantPotSizes: function () {
            return this.plant.plantPotSizeSet.edges.length > 0;
        },
        hasPlantTags: function () {
            return this.plant.plantTagSet.edges.length > 0;
        },
        sortedPotSizes: function () {
            var _sorted = this.plant.plantPotSizeSet.edges;

            if (_sorted.length > 0) {
                _sorted = _sorted.sort((a, b) => {
                    return a.node.potSize.potSizeCm - b.node.potSize.potSizeCm;
                });
            }

            return _sorted;
        }
    }
};
</script>